import { Table as CustomFieldTable } from '@/components/custom_field_value/table'
import { CustomFieldResource } from '@/types'

interface Props {
  venueId: string
}

export const EditCustomField = ({ venueId }: Props) => {
  return (
    <>
      <CustomFieldTable
        filters={ { resourceIdEq: venueId, resourceTypeEq: CustomFieldResource.Venue }}
        pageSize={10}
        title="Custom Fields"
        createable
        fixedHeight
        updateable
      />
    </>
  )
}
